import {
  loadLocalData,
  saveLocalData,
  STORAGE_KEY_TRANSACTIONS_STATE,
} from '@northladder/utilities';

import { IPersistableTransactionState } from '../types';

/**
 * This persists the transactions store  to secure device storage.
 */
export const persistTransactionsStore = (
  targetState: IPersistableTransactionState
) => {
  saveLocalData(STORAGE_KEY_TRANSACTIONS_STATE, targetState);
};

/**
 * This retrieves and decrypts the transactions store info from secure device storage.
 */
export const loadPersistedTransactionsStore = () =>
  loadLocalData<IPersistableTransactionState>(STORAGE_KEY_TRANSACTIONS_STATE);
